// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__aPoE4","title":"styles_title___s6pI","text":"styles_text__2YlWW"};